import type { AsyncData } from 'nuxt/app';
import type {
  PaymentIntentPayload,
  PurchaseBoostsPayload,
  PurchaseFeaturesPayload,
} from '../types';
import { useApiFetch } from '~/modules/support/fetch/runtime/composables/useApiFetch';

export default {
  getBillingDetails(): AsyncData<
    App.DataObjects.Payment.BillingDetailsData[],
    any
  > {
    return useApiFetch(useZiggy('agents.checkout.billing-details.index'), {
      method: 'GET',
      watch: false,
    });
  },
  removePaymentMethod(paymentMethodId: string): AsyncData<any, any> {
    return useApiFetch(
      useZiggy('agents.checkout.billing-details.destroy', paymentMethodId),
      {
        method: 'DELETE',
        watch: false,
      },
    );
  },
  createPaymentIntent(body: PaymentIntentPayload): AsyncData<any, any> {
    return useApiFetch(useZiggy('agents.checkout.payment-intent'), {
      method: 'POST',
      body,
      watch: false,
    });
  },
  createCheckoutSession(body: {
    type: 'boost' | 'feature';
    quantity?: number;
    properties?: Array<{ id: string; feature_duration: number }>;
    discount_code?: string | null;
  }): AsyncData<any, any> {
    return useApiFetch(useZiggy('agents.checkout.session'), {
      method: 'POST',
      body,
      watch: false,
    });
  },
  processSavedPayment(body: {
    type: 'boost' | 'feature';
    quantity?: number;
    properties?: Array<{ id: string; feature_duration: number }>;
    discount_code?: string | null;
    payment_method_id?: string | null;
  }): AsyncData<any, any> {
    return useApiFetch(useZiggy('agents.checkout.saved-payment'), {
      method: 'POST',
      body,
      watch: false,
    });
  },
  confirmSavedPayment(body: {
    payment_intent_id: string;
  }): AsyncData<any, any> {
    return useApiFetch(useZiggy('agents.checkout.confirm-saved-payment'), {
      method: 'POST',
      body,
      watch: false,
    });
  },
  verifyCheckoutSuccess(body: {
    session_id: string;
    type: string;
  }): AsyncData<any, any> {
    return useApiFetch(useZiggy('agents.checkout.success'), {
      method: 'GET',
      query: body,
      watch: false,
    });
  },
  boost: {
    purchase(body: PurchaseBoostsPayload): AsyncData<any, any> {
      return useApiFetch(useZiggy('agents.checkout.boost'), {
        method: 'POST',
        body,
        watch: false,
      });
    },
  },
  feature: {
    purchase(body: PurchaseFeaturesPayload): AsyncData<any, any> {
      return useApiFetch(useZiggy('agents.checkout.feature'), {
        method: 'POST',
        body,
        watch: false,
      });
    },
  },
};
